module.exports = __webpack_public_path__ + "img/deny.fda3a538.svg";